import {analytics} from '../../../web/init-fcm';
export default analytics;
